export { SpaLandingPageV2Connected as SpaLandingPageV2 } from './container';
